// extracted by mini-css-extract-plugin
export default {"wrapper":"W6CL62X5iM","highlight":"GZYQHtvxc2","code":"H_ln6xPVxG","copy":"npRyRQ6sLn","dark":"tmC6GzqQ_i"};